/**
 * Situação do contribuinte da empresa. Espelha SituacaoContribuinteEmpresaEnum (API Usuario e API
 * MotorFiscal): os valores são ids de db_motor_fiscal.situacao_contribuinte_empresa.
 */
export enum SituacaoContribuinteEmpresaEnum {
  NaoContribuinteIcms = 1,
  ContribuinteIcms = 2,
  ContribuinteExclusivoIbsCbs = 3,
}
